import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isCancel = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [state, setState] = useState(isCancel ? "cancel" : "checking");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    if (attempts > 8) { setState("timeout"); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") setState("success");
        else if (data.status === "failed" || data.payment_status === "failed") setState("failed");
        else setAttempts((a) => a + 1);
      } catch (_) {
        setAttempts((a) => a + 1);
      }
    }, 1500);
    return () => clearTimeout(t);
  }, [attempts, sessionId, isCancel]);

  const CONF = {
    checking: { icon: Loader2, spin: true, color: "text-sky-500", title: "Vérification du paiement…", sub: "Merci de patienter quelques instants." },
    success: { icon: CheckCircle2, color: "text-emerald-500", title: "Paiement confirmé !", sub: "Votre commande a bien été enregistrée. Merci." },
    failed: { icon: XCircle, color: "text-rose-500", title: "Paiement échoué", sub: "Aucun montant n'a été débité. Réessayez." },
    cancel: { icon: XCircle, color: "text-slate-400", title: "Paiement annulé", sub: "Vous avez annulé le paiement." },
    timeout: { icon: Loader2, color: "text-amber-500", title: "Paiement en cours de traitement", sub: "Cela prend plus de temps que prévu. Vérifiez vos commandes plus tard." },
  };
  const c = CONF[state];

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center animate-fade-up" data-testid="payment-return">
      <c.icon className={`w-16 h-16 ${c.color} ${c.spin ? "animate-spin" : ""}`} />
      <h1 className="text-2xl font-display font-bold text-navy mt-5" data-testid="payment-status-title">{c.title}</h1>
      <p className="text-slate-500 mt-2 max-w-md">{c.sub}</p>
      <div className="flex gap-3 mt-6">
        <button onClick={() => navigate("/boutique")} className="px-4 py-2.5 rounded-xl bg-white border border-slate-200 font-semibold hover:border-sky-300">
          Retour boutique
        </button>
        <button onClick={() => navigate("/")} className="px-4 py-2.5 rounded-xl bg-navy text-white font-semibold hover:bg-navy-deep">
          Tableau de bord
        </button>
      </div>
    </div>
  );
}
